import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsBrowser from "@/components/feature/NewsBrowser";
import PageEmpty from "@/components/feature/PageEmpty";
import { allTopics, getNewsByTopic, getTopic } from "@/utils/news";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function TopicPage() {
  const { topicId = "" } = useParams();
  const topic = getTopic(topicId);

  useDocumentTitle(
    topic ? `${topic.name}专题 - 911爆料` : "专题不存在 - 911爆料"
  );

  if (!topic) {
    return (
      <PageEmpty
        icon="ri-stack-line"
        title="未找到该专题"
        description="该爆料专题可能已下线，您可以浏览其他深度分析专题。"
        actionLabel="返回首页"
        actionTo="/"
      />
    );
  }

  const items = getNewsByTopic(topic.id);
  const relatedTopics = allTopics.filter((item) => item.id !== topic.id);

  return (
    <div className="animate-fade-up">
      <section className="relative w-full overflow-hidden border-b border-background-200">
        <div className="absolute inset-0">
          <img
            src={topic.cover}
            alt={topic.name}
            title={`${topic.name} - 911爆料专题`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/80 to-background-50/40" />
        </div>
        <div className="relative mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
          <div className="max-w-2xl">
            <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
              爆料专题
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              {topic.name}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {topic.summary}
            </p>
          </div>
        </div>
      </section>

      <div className="mx-auto w-full max-w-shell px-4 py-8 md:px-6 md:py-10">
        <Breadcrumb
          items={[
            { label: "首页", to: "/" },
            { label: "爆料专题" },
            { label: topic.name },
          ]}
        />

        <div className="mt-8">
          <NewsBrowser
            items={items}
            emptyText="该专题暂无爆料内容。"
          />
        </div>

        <section className="mt-14 border-t border-background-200 pt-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">
            推荐相关专题
          </h2>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {relatedTopics.map((item) => (
              <Link
                key={item.id}
                to={`/topic/${item.id}`}
                className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-500"
              >
                <h3 className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.name}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <span className="mt-4 flex items-center gap-1 text-xs text-accent-400">
                  查看专题
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}